document.addEventListener('DOMContentLoaded', () => {
  const investmentSelect = document.getElementById('sc-investment');
  if (!investmentSelect) return;

  const personsInput = document.getElementById('sc-persons');
  const areaInput = document.getElementById('sc-area');
  const incomeInput = document.getElementById('sc-income');
  const resultAmountEl = document.getElementById('sc-result-amount');
  const incomeResultEl = document.getElementById('sc-income-result');

  const avgSalary = parseFloat(investmentSelect.dataset.avgSalary || '0');

  function computeSubsidy(ko, osoby, metr) {
    const doplataMiesieczna = (0.018 * ko) / 12;
    const powierzchniaNormatywna = 20 + 15 * (osoby - 1);
    const limitDochodow = (1 + 0.4 * (osoby - 1)) * avgSalary;
    const powierzchnia = Math.min(metr, powierzchniaNormatywna);
    return {
      doplata: doplataMiesieczna * powierzchnia,
      limitDochodow,
    };
  }

  function getSelectedKo() {
    const option = investmentSelect.selectedOptions[0];
    if (!option) return null;
    const ko = parseFloat(option.dataset.ko);
    return ko > 0 ? ko : null;
  }

  function showResult(doplata) {
    resultAmountEl.textContent = doplata.toLocaleString('pl-PL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' zł';
  }

  function showIncomeResult(dochody, limitDochodow) {
    const msg = dochody <= limitDochodow ? incomeResultEl.dataset.msgYes : incomeResultEl.dataset.msgNo;
    incomeResultEl.innerHTML = `<p class="sc-qualify fw-bolder">${msg}</p>`;
    incomeResultEl.classList.remove('d-none');
  }

  function calculate() {
    resultAmountEl.textContent = '';
    incomeResultEl.classList.add('d-none');

    const ko = getSelectedKo();
    const osoby = parseInt(personsInput.value, 10);
    const metr = parseFloat(areaInput.value.replace(',', '.'));

    if (!ko || !osoby || osoby < 1 || isNaN(osoby) || !metr || metr < 1 || isNaN(metr)) return;

    const { doplata, limitDochodow } = computeSubsidy(ko, osoby, metr);
    showResult(doplata);

    const dochody = parseFloat(incomeInput.value.replace(',', '.'));
    if (dochody > 0) showIncomeResult(dochody, limitDochodow);
  }

  function onIncomeChange() {
    if (!resultAmountEl.textContent) return;

    incomeResultEl.classList.add('d-none');

    const ko = getSelectedKo();
    const osoby = parseInt(personsInput.value, 10);
    const metr = parseFloat(areaInput.value.replace(',', '.'));
    const dochody = parseFloat(incomeInput.value.replace(',', '.'));

    if (!ko || !osoby || !metr || !dochody || dochody <= 0) return;

    const { limitDochodow } = computeSubsidy(ko, osoby, metr);
    showIncomeResult(dochody, limitDochodow);
  }

  function debounce(fn, delay) {
    let timer;
    return function () { clearTimeout(timer); timer = setTimeout(fn, delay); };
  }

  investmentSelect.addEventListener('change', calculate);
  personsInput.addEventListener('change', calculate);
  personsInput.addEventListener('input', debounce(calculate, 600));
  areaInput.addEventListener('change', calculate);
  areaInput.addEventListener('input', debounce(calculate, 600));
  incomeInput.addEventListener('change', onIncomeChange);
  incomeInput.addEventListener('input', debounce(onIncomeChange, 600));
});
